export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={`text-xl font-bold tracking-tight ${className ?? ""}`}>
      Kleip<span className="text-brand-cyan">Data</span>
    </span>
  );
}
